var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('header', [_c('Topbar', {
    on: {
      "aloneView": _vm.aloneView,
      "quitAloneView": _vm.quitAloneView
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('Editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aloneViewMode),
      expression: "aloneViewMode"
    }]
  }), _vm._v(" "), _c('Preview', {
    class: {
      aloneViewMode: !_vm.aloneViewMode
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b05f3372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = /eqo
// module chunks = 1